import { CurrencyPipe, DecimalPipe, PercentPipe } from "@angular/common";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { PcaDashboardService } from "../pca-dashboard-service/pca-dashboard.service";
import { ConversaoLibraConverte } from "./../../../../shared/conversao-libra/conversao-libra-converte";
import { Filtros } from "./../../../../shared/crud/Filtro/Filtros";
import { ListaBase } from "./../../../../shared/crud/ListaBase";
import { ExportExcelService } from "./../../../../shared/excel-service/export-excel.service";

@Component({
  selector: "app-pca-dashboard-lista",
  templateUrl: "./pca-dashboard-lista.component.html",
  styles: [
    `
      .text-right {
        text-align: right;
      }
    `,
  ],
  styleUrls: ["./pca-dashboard-lista.component.css"],
})
export class PcaDashboardListaComponent extends ListaBase implements OnInit {
  nomeDealer: any;
  quantidadeDealer: number = 0
  totalMos: number = 0
  totalCusto: number = 0
  totalMediaMensalVarejo: number = 0
  totalObsoletos: number = 0
  totalPercentual: number = 0
  totalVarejo: number = 0
  totalGiro: number = 0
  carregando = false;
  parametrosFiltro: any;
  filtors: any = {};
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  cols: any[];
  _selectedColumns: any[];
  filtroconsolidado = false;
  filtropecas = true;
  filtroroupas = true;
  filtroacessorios = true;
  titulo = "PCA-CONSOLIDADO";
  tipo: any;
  data: any;
  tempDados: any;
  subscription;

  dadosTranslate = {
    Nome: "estoque.pcaDashboard.nome",
    Custo: "estoque.pcaDashboard.custo",
    Varejo: "estoque.pcaDashboard.varejo",
    Obsoletos: "estoque.pcaDashboard.obsoletos",
    "Média Mensal Varejo (3 meses)": "estoque.pcaDashboard.mediaMensalVarejo",
    Giro: "estoque.pcaDashboard.giro",
    Brasil: "estoque.pcaDashboard.brasil",
  };


  constructor(
    service: PcaDashboardService,
    toast: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private currency: CurrencyPipe,
    private number: DecimalPipe,
    private percent: PercentPipe,
    private conversaoLibraConverte: ConversaoLibraConverte
  ) {
    super(service, toast, router);
    this.filtros = {};
    this.nomeModulo = "pca-dashboard";
  }

  @Input() set carregar(valores: any[]) {
    if (valores.length > 0) {
      this.limparFiltros();
      valores.forEach((item) => {
        new FiltroDealer(new FiltroEspecifico(null)).gerar(item, this.filtros);
      });
    } else {
      this.limparFiltros();
    }
  }

  ngOnInit(): void {
    this.setaValorData(null, null);
    this.buscar();
    this.cols = [
      { field: "codigo_dealer", header: "Dealers" },
      { field: "nome_dealer", header: "estoque.pcaDashboard.nome" },
      { field: "custo", header: "estoque.pcaDashboard.custo", type: this.currency, arg1: " " },
      { field: "varejo", header: "estoque.pcaDashboard.varejo", type: this.currency, arg1: " " },
      { field: "obsoletos", header: "estoque.pcaDashboard.obsoletos", type: this.currency, arg1: " " },
      { field: "percentual", header: "%", type: this.percent, arg1: "1.0-0" },
      { field: "media_mensal_varejo", header: "estoque.pcaDashboard.mediaMensalVarejo", type: this.currency, arg1: " ", },
      { field: "mos", header: "MOS" },
      { field: "giro", header: "estoque.pcaDashboard.giro", type: this.number, arg1: "1.2-2" },
    ];

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (_event: LangChangeEvent) => {
        this.buscar();
      }
    );
    //fimConversaolibra

    this._selectedColumns = this.cols;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter((col) => val.includes(col));
  }

  setaValorData(data: any, tipo: any) {
    //set data
    if (data === undefined || data === null) {
      this.data = this.dataAtualFormatada();
    } else {
      this.data = data;
    }
    //set tipo
    if (tipo === undefined || tipo === null) {
      this.tipo = [1, 2, 3];
    } else {
      this.tipo = tipo;
    }

    this.filtros = { data: this.data, tipo: this.tipo };
  }

  dataAtualFormatada() {
    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {
          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.carregando = true
    this.service.buscar(objFiltro).then((res) => {
      res.dados.forEach((dados) => {
        dados.custo = Number(this.conversaoLibraConverte.conversaoLibra(dados.custo, null, null).toFixed(2));
        dados.media_mensal_varejo = Number(this.conversaoLibraConverte.conversaoLibra(dados.media_mensal_varejo, null, null).toFixed(2));
        dados.obsoletos = Number(this.conversaoLibraConverte.conversaoLibra(dados.obsoletos, null, null).toFixed(2));
        dados.varejo = Number(this.conversaoLibraConverte.conversaoLibra(dados.varejo, null, null).toFixed(2));
        if (dados.varejo == 0) {
          dados.giro = 0;
        } else {
          dados.giro = ((dados.media_mensal_varejo * 12) /dados.varejo).toFixed(2);
        }
        if (dados.custo == 0) {
          dados.percentual = 0;
        } else {
          dados.percentual = dados.obsoletos / dados.custo;
        }
        if (dados.media_mensal_varejo == 0) {
          dados.mos = 0;
        } else {
          dados.mos = Math.trunc(dados.varejo / dados.media_mensal_varejo);
        }
      });      
      this.tempDados = res;
      this.carregando = false
      this.calculandoTotal(res)
    });
  }

  calculandoTotal(res) {
    this.quantidadeDealer = res.totalDealers;
    this.nomeDealer = 'Brasil';
    this.totalCusto = res.totalCusto;
    this.totalMediaMensalVarejo = res.totalMediaMensalVarejo;
    this.totalObsoletos = res.totalObsoletos;
    this.totalVarejo = res.totalVarejo;
    this.totalGiro = res.totalGiro;
    this.totalPercentual = res.totalPercentual;
    this.totalMos = res.totalMos;
  }

  consolidado() {
    this.filtroconsolidado = false;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = [1, 2, 3];


    this.titulo = "PCA-CONSOLIDADO";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  pecas() {
    this.filtroconsolidado = true;
    this.filtropecas = false;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = 3;


    this.titulo = "PEÇAS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  roupas() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = false;
    this.filtroacessorios = true;
    this.tipo = 2;
    this.titulo = "ROUPAS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  acessorios() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = false;
    this.tipo = 1;
    this.titulo = "ACESSÓRIOS";
    this.setaValorData(null, this.tipo);
    this.buscar();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial || this.filtros.data_final;
  }

  limparFiltros(): any {
    this.filtros.dealers = "";
    this.filtros.data_inicial = null;
    this.filtros.data_final = null;
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  getTranslate(value) {
    if (value.nome_dealer === "Calculando...") {
      return (value.nome_dealer = "estoque.pcaDashboard.calculando");
    }

    return this.dadosTranslate[value];
  }

}

abstract class GerarFiltro {
  proximoGerador: GerarFiltro;

  constructor(proximoGerador: GerarFiltro) {
    this.proximoGerador = proximoGerador;
  }
  public abstract gerar(item: any, filtros: any);
}

class FiltroDealer extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    if (item.chave === "dealers") {
      const itens: string[] = [];
      item.valor.forEach((element) => {
        itens.push(element);
      });
      filtros.dealers = itens;
    } else {
      this.proximoGerador.gerar(item, filtros);
    }
  }
}

class FiltroEspecifico extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    filtros[item.chave] = item.valor;
  }
}
